var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInkwell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.7 51.75-21.51.33c-.13 4.05.76 9.38 4.87 11.28 3.75 1.74 11.3 1.35 14.24-1.85 2.27-2.47 2.51-6.25 2.4-9.44zM8.05 47.1v2.95l8.57-.13c.03-.94.05-1.88.08-2.82zM48.19 14.25c4.91-1.28 11.03-1.33 15.63 1-1.58-3.84-3.74-6.76-6.99-9.26-2.86-2.19-6.16-3.8-9.77-4.25-12.44-1.55-23.61 10.49-25 22.2-1.61-2.85-2.3-6.22-1.94-9.48-5.83 5.35-13.14 14.81-6.05 22.28.04.04.08.07.12.11 7.1-12.74 18.16-26.45 33.93-30.04a.966.966 0 0 1 1.16.73c.03.15.02.3-.01.44-5.41 1.36-10.25 3.91-14.56 7.19-8.15 5.94-14.42 14.66-19 22.93.06.04.13.07.2.11-.94 1.7-1.8 3.37-2.6 5H5c-.54 0-.97.43-.97.97s.43.97.97.97h14.16c.54 0 .97-.43.97-.97s-.43-.97-.97-.97h-3.69c.68-1.36 1.4-2.74 2.18-4.14 2.23.85 4.76.98 7.06.42 3.37-.81 6.33-2.97 8.43-5.72 1.8-2.36 3.57-5.09 6.11-6.74 2.48-1.61 6.76-3 9.72-2.96-1.73-1.14-3.66-2.06-5.66-2.6-1.82-.49-3.67-.18-5.49-.6.96-3.86 7.03-5.75 10.37-6.62z",
    fill: "var(--primary-color)",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkwell);
export default __webpack_public_path__ + "static/media/inkwell.10c45f0d8e37a29f67a98e218e8c29a3.svg";
export { ForwardRef as ReactComponent };